import React from 'react'
import { connect } from 'react-redux'
import { loginAndRestartAppAction, signInAction } from 'actions/applicationActions'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { login } from 'api/login'
import { OFFLINE_DEVICE_LIMITS } from 'helpers/globals'

const mapStateToProps = ({ createdAt, active, ui }) => {
  return {
    createdAt,
    active,
    deviceLimitType: ui && ui.deviceLimitType,
    offlineTimeLimit: ui && ui.offlineTimeLimit
  }
}

class LoginForm extends React.Component {
  state = { loading: false }

  loginAndRestartApp = async function() {
    this.setState({ loading: true, message: '' })
    const { refs: { email, password, otp }, props: { createdAt, resetState, loginAndRestartAppAction, signInAction } } = this
    try {
      const { prompt_for_otp, active } = await login({ login: email.value, password: password.value, ...(otp && { otp_attempt: otp.value }) })
      // eslint-disable-next-line camelcase
      if (prompt_for_otp) {
        this.setState({ otpRequired: true, loading: false, message: '2FA Token Required for Login' })
      } else {
        if (createdAt) loginAndRestartAppAction(active)
        else {
          resetState()
          signInAction(active)
        }
      }
    } catch (e) {
      this.setState({
        message: e.message.includes('401') ? 'Incorrect credentials.' : 'Something went wrong, please try again.',
        loading: false
      })
      setTimeout(_ => this.setState({ message: '' }), 2000)
    }
  }

  limitText = _ => {
    const { deviceLimitType, offlineTimeLimit } = this.props

    if (offlineTimeLimit) return 'To continue using the Designer / Calculator'
    if (deviceLimitType === 'other device') return 'To add more devices'
    return `To add more than ${OFFLINE_DEVICE_LIMITS[deviceLimitType]} ${deviceLimitType}`
  }

  render() {
    const { loginAndRestartApp, limitText, state: { loading, message, otpRequired }, props: { active, close, deviceLimitType, offlineTimeLimit, classes } } = this

    if (active === false) {
      return (
        <div className={classes.container}>
          { deviceLimitType || offlineTimeLimit
            ? <p style={{ marginBottom: 0 }}>
                {limitText()}, <a href={`${IPVM_URL}/settings`} target='_blank'>reactivate</a> your subscription.
              </p>
            : <p style={{ marginBottom: 0 }}>
                <a href={`${IPVM_URL}/settings`} target='_blank'>Reactivate</a> your subscription to access Subscriber Designer / Calculator capabilities.
              </p>
          }
        </div>
      )
    }

    return (
      <div className={classes.container}>
        <p>
          { deviceLimitType || offlineTimeLimit
            ? `${limitText()}, you must be an IPVM subscriber. `
            : "You've selected a feature that is available exclusively to IPVM subscribers. "
          }
          Please login using the form below or
          <a href={`${IPVM_URL}/join/design_calculator`} target='_blank'> get full Designer / Calculator access for $199 annually now</a>.
        </p>
        <input ref='email' type='text' defaultValue='' name='email' placeholder='Email' />
        <input ref='password' type='password' defaultValue='' name='password' placeholder='Password' />
        {
          otpRequired
          ? <input ref='otp' type='text' defaultValue='' name='otp' placeholder='2FA Token' />
          : null
        }
        <a href='https://ipvm.com/password/new' target='_blank' className={classes.forgotPasswordButton}>Forgot your password?</a>
        <span className={classes.errorMessage}>{message}</span>
        <hr style={{ marginTop: 10 }}/>
        <div className={classes.buttons}>
          <button
            className={classes.loginButton}
            onClick={loginAndRestartApp.bind(this)}
            type='button'
            disabled={loading}
          >
            { loading ? <FontAwesomeIcon icon='sync' className={classes.loadingIcon} /> : 'Login' }
          </button>
          { !offlineTimeLimit &&
            <button
              className={classes.closeButton}
              onClick={close}
            >
              Close
            </button>
          }
        </div>
      </div>
    )
  }
}

export const LoginFormConfig = { title: 'Subscriber Only Feature' }
export default connect(mapStateToProps, { loginAndRestartAppAction, signInAction })(
  injectSheet(style)(LoginForm)
)



// WEBPACK FOOTER //
// ./src/components/LoginForm/index.js